class StickyBuyButton extends HTMLElement {
  constructor() {
    super();

    this.activeClass = "wt-product__sticky-buy--show";
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    const addToCartModule = document.querySelector(".wt-product__add-to-cart");
    const btn = this.querySelector("button");
    const addToCart = this.dataset.addToCart === "";

    const forObserver = document.querySelectorAll(
      ".wt-product__add-to-cart, .wt-footer, .wt-product__name",
    );

    let intersected = [];

    btn.addEventListener("click", (e) => {
      if (!addToCart) {
        e.preventDefault();
      }
      addToCartModule.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        isIntersecting
          ? intersected.push(target)
          : (intersected = intersected.filter((item) => item !== target));
      });

      if (intersected.length) {
        this.classList.remove(this.activeClass);
      } else {
        this.classList.add(this.activeClass);
      }
    });

    forObserver.forEach((item) => {
      observer.observe(item);
    });
  }
}

customElements.define("sticky-buy-button", StickyBuyButton);

// Handle custom "Buy Now" button behavior: add variant to cart then go to checkout
document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-custom-buy-now");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
    let sectionEl = btn.closest("[data-section-id]");
    let modal = sectionEl?.querySelector('.wt-product__modal[data-buy-now-details]');

    // Support external trigger (button outside product section)
    if (!modal) {
      modal = document.querySelector('.wt-product__modal[data-buy-now-details]');
      if (modal) sectionEl = modal.closest("[data-section-id]");
    }

    if (modal) modal._triggerBtn = btn;

    const getSelectedExternalPackage = () => {
      const selectedInput = document.querySelector(".wt-variant-options.wt-package-picker input[type='radio']:checked");
      if (!selectedInput) return null;
      const packageName =
        selectedInput.dataset.packageName ||
        selectedInput.value ||
        selectedInput
          .closest(".wt-package-picker__item")
          ?.querySelector(".wt-package-picker__title")
          ?.textContent
          ?.trim() ||
        "";
      return {
        id: selectedInput.dataset.variantId || "",
        name: packageName,
      };
    };

    if (modal && btn.dataset.modalApproved !== "1") {
      let pkgName = "";
      if (btn.dataset.externalTrigger === "true" && window.selectedPackageVariant && window.selectedPackageVariant.name) {
        pkgName = window.selectedPackageVariant.name;
      } else if (btn.dataset.externalTrigger === "true") {
        const externalPkg = getSelectedExternalPackage();
        pkgName = externalPkg?.name || "";
      } else {
        const pkgEl = sectionEl.querySelector(".wt-package-picker__item input:checked + label .wt-package-picker__title");
        pkgName = pkgEl ? pkgEl.textContent.trim() : "";
      }
      const pkgOut = modal.querySelector(".js-buy-now-package");
      if (pkgOut) pkgOut.textContent = pkgName;
      const dob = modal.querySelector(".js-order-dob");
      if (dob) {
        const today = new Date().toISOString().split("T")[0];
        dob.setAttribute("max", today);
      }
      const getActiveModelSelect = () => {
        const selects = modal.querySelectorAll(".js-order-model");
        for (const s of selects) {
          const wrap = s.closest(".js-device-select");
          if (wrap && !wrap.hasAttribute("hidden")) return s;
        }
        return selects[0] || null;
      };
      const typeBtns = modal.querySelectorAll(".js-device-type");
      const deviceWraps = modal.querySelectorAll(".js-device-select");
      const cp = modal.querySelector(".js-order-consent-prescribed");
      const cpol = modal.querySelector(".js-order-consent-policies");
      const cpNvWa = modal.querySelector(".js-order-consent-nv-wa");
      const cm = modal.querySelector(".js-order-consent-marketing");
      const go = modal.querySelector(".js-buy-now-continue");
      let setDeviceType;
      const validate = () => {
        const textInputs = [dob];
        const modelSel = getActiveModelSelect();
        const selects = [modelSel];
        const requiredCheckboxes = [cp, cpol];
        const invalidText = textInputs.some((el) => el && !el.checkValidity());
        const invalidSelect = selects.some((el) => !el || !el.value);
        const invalidCheckbox = requiredCheckboxes.some((el) => el && !el.checked);
        if (go) go.disabled = invalidText || invalidSelect || invalidCheckbox;
      };
      const closeModal = () => {
          modal.classList.add("closing");
          setTimeout(() => {
            modal.removeAttribute("open");
            modal.classList.remove("closing");
          }, 200);
        };
      setDeviceType = (type) => {
        deviceWraps.forEach((wrap) => {
          const isTarget = wrap.dataset.device === type;
          const sel = wrap.querySelector("select");
          if (isTarget) {
            wrap.removeAttribute("hidden");
            wrap.removeAttribute("aria-hidden");
            if (sel) {
              sel.removeAttribute("disabled");
              sel.setAttribute("required", "required");
            }
          } else {
            wrap.setAttribute("hidden", "");
            wrap.setAttribute("aria-hidden", "true");
            if (sel) {
              sel.setAttribute("disabled", "");
              sel.removeAttribute("required");
              sel.value = "";
            }
          }
        });
        typeBtns.forEach((b) => {
          const isActive = b.dataset.type === type;
          b.classList.toggle("active", isActive);
          b.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      };
      if (!modal.dataset.init) {
        modal.addEventListener("click", async (ev) => {
          const insideContent = ev.target.closest(".wt-product__modal--content");
          if (!insideContent) {
            ev.preventDefault();
            closeModal();
            return;
          }
          const x = ev.target.closest(".js-buy-now-close");
          if (x) {
            ev.preventDefault();
            closeModal();
          }
          const typeBtn = ev.target.closest(".js-device-type");
          if (typeBtn) {
            ev.preventDefault();
            const t = typeBtn.dataset.type;
            if (t === "android" || t === "ios") {
              setDeviceType(t);
              validate();
            }
          }
          const cont = ev.target.closest(".js-buy-now-continue");
          if (cont) {
            ev.preventDefault();
            if (cont.classList.contains("loading")) {
              return;
            }
            cont.classList.add("loading");
            cont.setAttribute("aria-disabled", "true");
            cont.disabled = true;
            const modelSel = getActiveModelSelect();
            const attrs = {
              "Date of birth": dob?.value || "",
              "Device model": modelSel?.value || "",
              "Consent: Prescribed": cp?.checked ? "Yes" : "",
              "Consent: Policies": cpol?.checked ? "Yes" : "",
              "Consent: Nevada & Washington privacy": cpNvWa?.checked ? "Yes" : "",
              "Consent: Marketing": cm?.checked ? "Yes" : ""
            };
            const form = sectionEl?.querySelector("product-form form, form");
            if (form) {
              const setVal = (sel, val) => {
                const el = form.querySelector(sel);
                if (el) el.value = val;
              };
              setVal('[name="properties[Date of birth]"]', attrs["Date of birth"]);
              setVal('[name="properties[Device model]"]', attrs["Device model"]);
              setVal('[name="properties[Consent: Prescribed]"]', attrs["Consent: Prescribed"]);
              setVal('[name="properties[Consent: Policies]"]', attrs["Consent: Policies"]);
              setVal('[name="properties[Consent: Nevada & Washington privacy]"]', attrs["Consent: Nevada & Washington privacy"]);
              setVal('[name=\"properties[Consent: Marketing]\"]', attrs["Consent: Marketing"]);
            }
            try {
              await fetch("/cart/update.js", {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ attributes: attrs })
              });
            } catch (_) {}
            cont.classList.remove("loading");
            cont.removeAttribute("aria-disabled");
            cont.disabled = false;
            
            const triggerBtn = modal._triggerBtn || btn;
            triggerBtn.dataset.modalApproved = "1";
            closeModal();
            triggerBtn.click();
          }
        });
        ["input","change"].forEach((evt) => {
          modal.querySelectorAll(".js-order-model").forEach((s)=>s.addEventListener(evt, validate));
          cp?.addEventListener(evt, validate);
          cpol?.addEventListener(evt, validate);
          cpNvWa?.addEventListener(evt, validate);
          cm?.addEventListener(evt, validate);
        });

        const handleDobInput = () => {
          if (dob.value) {
            const max = dob.getAttribute('max');
            if (max && dob.value > max) {
              dob.value = max;
            }
          }
          validate();
        };
        dob?.addEventListener('input', handleDobInput);
        dob?.addEventListener('change', validate);

        modal.dataset.init = "1";
      }
      modal.setAttribute("open", "");
      modal.classList.add("opening");
      setTimeout(()=>modal.classList.remove("opening"), 250);
      // Reset initial device selection state
      deviceWraps.forEach((w)=>{
        w.setAttribute("hidden","");
        w.setAttribute("aria-hidden","true");
        const sel = w.querySelector("select");
        if (sel) {
          sel.setAttribute("disabled","");
          sel.removeAttribute("required");
          sel.value = "";
        }
      });
      typeBtns.forEach((b)=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
      let defaultType = null;
      const defaultWrap = modal.querySelector('.js-device-select[data-default="true"]');
      if (defaultWrap) defaultType = defaultWrap.dataset.device;
      if (!defaultType && typeBtns[0]) defaultType = typeBtns[0].dataset.type;
      if (defaultType) {
        setDeviceType(defaultType);
      }
      const goBtn = modal.querySelector(".js-buy-now-continue");
      if (goBtn) goBtn.disabled = true;
      return;
    }
    let productFormEl =
      btn.closest("product-form")?.querySelector("form") || btn.closest("form");
    
    // Fallback for external trigger
    if (!productFormEl && sectionEl) {
      productFormEl = sectionEl.querySelector("product-form form, form");
    }

    const idInput = productFormEl ? productFormEl.querySelector('input[name="id"]') : null;
    
    let variantId = null;
    const isExternal = btn.dataset.externalTrigger === "true";
    if (isExternal && window.selectedPackageVariant && window.selectedPackageVariant.id) {
        variantId = Number(window.selectedPackageVariant.id);
    } else if (isExternal) {
        const externalPkg = getSelectedExternalPackage();
        if (externalPkg && externalPkg.id) {
          variantId = Number(externalPkg.id);
        }
    } else if (idInput && idInput.value) {
        variantId = Number(idInput.value);
    }

    if (!variantId || Number.isNaN(variantId)) return;
    const qtyInput = productFormEl ? productFormEl.querySelector('input[name="quantity"]') : null;
    const spInput = productFormEl ? productFormEl.querySelector('[name="selling_plan"]') : null;
    const quantity = parseInt(qtyInput?.value || "1", 10) || 1;
    
    const properties = {};
    if (productFormEl) {
      productFormEl
        .querySelectorAll("[name^='properties[']")
        .forEach((el) => {
          const m = el.name.match(/\[(.*)\]/);
          if (!m || !m[1]) return;
          let val;
          if (el.type === "checkbox") {
            val = el.checked ? el.value || "Yes" : "";
          } else {
            val = el.value;
          }
          if (val !== "" && val != null) properties[m[1]] = val;
        });
    }

    const line = {
      id: variantId,
      quantity,
    };
    if (spInput && spInput.value) line.selling_plan = Number(spInput.value);
    if (Object.keys(properties).length) line.properties = properties;
    const setPayload = { items: [line] };
    btn.classList.add("loading");
    btn.setAttribute("aria-disabled", "true");
    btn.setAttribute("disabled", "disabled");
    try {
      let ok = false;
      // Prefer cart/set.js to ensure a single item checkout
      const resSet = await fetch("/cart/set.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(setPayload),
      });
      if (resSet.ok) {
        ok = true;
      } else {
        // Fallback: clear cart then add
        await fetch("/cart/clear.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        const resAdd = await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(line),
        });
        ok = resAdd.ok;
      }
      if (!ok) throw new Error("Cart update failed");
      window.location.href = "/checkout";
    } catch (err) {
      btn.classList.remove("loading");
      btn.removeAttribute("aria-disabled");
      btn.removeAttribute("disabled");
      const errWrapper = btn
        .closest("product-form")
        ?.querySelector(".product-form__error-message-wrapper");
      const errMsg = errWrapper?.querySelector(".product-form__error-message");
      if (errWrapper && errMsg) {
        const msg =
          btn.dataset.errorCheckoutFailed || "Unable to start checkout. Please try again.";
        errMsg.textContent = msg;
        errWrapper.removeAttribute("hidden");
      }
    }
  },
  true,
);

if (!customElements.get("gallery-fashion")) {
  customElements.define(
    "gallery-fashion",
    class GalleryFashion extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("section");
        this.logoBanner = this;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.removeEventsWhenDesignMode();
      }

      addEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.addEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.addEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      removeEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.removeEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.removeEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      reinitAfterDelay() {
        setTimeout(() => this.reinit(), 0);
      }

      isFirstSection() {
        const sectionWrapper = document.querySelector("#root");
        const firstSection = sectionWrapper.querySelector("section");
        this.section = this.closest("section");
        const currentSection = this.section;

        return firstSection === currentSection;
      }

      handleResize() {
        this.setTopMargin();
        this.positioningProductInfo();
      }

      observeHeader() {
        const header = document.querySelector(".wt-header");
        const activeTransparentClass = "wt-header--fashion-transparent";

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 },
        );

        observer.observe(this.querySelector(".wt-product__gallery"));
      }

      calculateOffset() {
        const header = document.querySelector("header");
        const headerHeight = header.offsetHeight;
        const offset =
          this.isTransparentHeaderEnabled() && this.isFirstSection()
            ? headerHeight
            : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        if (offset) {
          this.section.style.marginTop = `-${offset}px`;
        } else {
          this.section.style.marginTop = 0;
        }
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector(".wt-header");
        return (
          header.dataset.transparent &&
          header.classList.contains("wt-header--v3")
        );
      }

      renderProgressBar() {
        const thumbsGallery = this.querySelector("[data-thumbs]");
        const progressBarElement = document.createElement("div");
        progressBarElement.classList.add("gallery-fashion__progress-bar");
        const progressBarIndicatorElement = document.createElement("div");
        progressBarIndicatorElement.classList.add(
          "gallery-fashion__progress-bar-indicator",
        );
        progressBarElement.appendChild(progressBarIndicatorElement);
        thumbsGallery.appendChild(progressBarElement);

        function updateProgressBar() {
          const images = this.querySelector("gallery-section");
          const progressBar = progressBarIndicatorElement;

          const scrolled = window.scrollY;
          const maxHeight = images.clientHeight - window.innerHeight;
          const scrollPercentage = (scrolled / maxHeight) * 100;

          const progressBarHeight = progressBarElement.clientHeight;
          const progressHeight = progressBar.clientHeight;
          const maxProgressTop = progressBarHeight - progressHeight;
          const progressTop = Math.min(
            (scrollPercentage / 100) * maxProgressTop,
            maxProgressTop,
          );

          progressBar.style.top = `${progressTop}px`;

          if (progressTop === maxProgressTop) {
            thumbsGallery.classList.add("finished");
          } else {
            thumbsGallery.classList.remove("finished");
          }
        }

        window.addEventListener("scroll", updateProgressBar.bind(this));

        function handleThumbsClick(event) {
          if (event.target.closest(".thumbs-list-item")) {
            const thumbnails = Array.from(
              event.currentTarget.querySelectorAll(".wt-product__img"),
            );
            const targetImage = event.target
              .closest(".thumbs-list-item")
              .querySelector(".wt-product__img");
            const index = thumbnails.indexOf(targetImage);
            const fullImage = this.querySelectorAll(
              ".wt-masonry__wrapper .wt-product__img, .wt-masonry__wrapper .wt-product__thumbnail-video",
            )[index];

            fullImage.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        thumbsGallery.addEventListener("click", handleThumbsClick.bind(this));
      }

      positioningProductInfo() {
        const productInfo = this.querySelector(".wt-product__main");
        const mediaDesktop = window.matchMedia("(min-width: 1200px)");

        if (mediaDesktop.matches) {
          productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
        }

        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (mediaDesktop.matches) {
              productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
            }
          }
        });

        const observedElement = productInfo;
        resizeObserver.observe(observedElement);
      }

      attachEvents() {
        window.addEventListener("resize", this.handleResize.bind(this));
      }

      /**
       * Wait until all images inside masonry wrapper are loaded
       * then run callback
       */
      waitForMasonryImages(callback) {
        const masonry = this.querySelector(".swiper-wrapper--masonry");
        if (!masonry) return;

        const images = masonry.querySelectorAll("img");
        if (images.length === 0) {
          callback();
          return;
        }

        let loaded = 0;
        const checkDone = () => {
          loaded++;
          if (loaded === images.length) {
            callback();
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            checkDone();
          } else {
            img.addEventListener("load", checkDone, { once: true });
            img.addEventListener("error", checkDone, { once: true });
          }
        });
      }

      init() {
        this.reinitAfterDelay = this.reinitAfterDelay.bind(this);
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            this.waitForMasonryImages(() => {
              const masonry = this.querySelector(".swiper-wrapper--masonry");
              if (masonry) {
                stickyHeaderThreshold.style.height = `${masonry.offsetHeight}px`;
              }
            });
          }
          this.setTopMargin();
          this.observeHeader();
          this.attachEvents();
        }

        this.renderProgressBar();
        this.positioningProductInfo();
        this.addEventsWhenDesignMode();
      }

      reinit() {
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
        }
        this.positioningProductInfo();
      }
    },
  );
}
